export const CONSENT_SOURCE_REQUIRED_MESSAGE = "Bitte geben Sie die Quelle an.";
export const CONSENT_TIMESTAMP_REQUIRED_MESSAGE = "Bitte geben Sie den Zeitpunkt an.";
export const CONSENT_TEXT_REQUIRED_MESSAGE = "Bitte hinterlegen Sie den Textbaustein.";

export function hasDocumentedConsent(entity) {
  return Boolean(entity && entity.consentGiven);
}

export function validateConsentMetadata(values) {
  if (!values || !values.consentGiven) {
    return {};
  }

  const errors = {};
  if (!values.consentSource || !values.consentSource.trim()) {
    errors.consentSource = CONSENT_SOURCE_REQUIRED_MESSAGE;
  }
  if (!values.consentTimestamp) {
    errors.consentTimestamp = CONSENT_TIMESTAMP_REQUIRED_MESSAGE;
  }
  if (!values.consentText || !values.consentText.trim()) {
    errors.consentText = CONSENT_TEXT_REQUIRED_MESSAGE;
  }
  return errors;
}
